import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/FellowshipsTable.css';

const FELLOWSHIP_KEYS = [
  'englishPrayerMeeting',
  'chinesePrayerMeeting',
  'fridayNightFellowship',
  'godkeyFellowship',
  'mandarinFellowship',
  'qaTheologyDiscussion',
  'chineseEveningService',
];

const FellowshipsTable = () => {
  const { t } = useLanguage();

  return (
    <section className="fellowships-section home-fellowships" id="weekly-gatherings">
      <div className="fellowships-container">
      <div className="fellowships-header">
        <h2 className="siteHeadings">{t('fellowships.weeklyHeading')}</h2>
      </div>

      {/* Desktop: Table */}
      <div className="table-wrapper">
        <table className="fellowships-table">
          <thead>
            <tr className="table-header-row">
              <th className="table-header fellowship-col">{t('fellowships.colFellowship')}</th>
              <th className="table-header day-time-col">{t('fellowships.colDayTime')}</th>
            </tr>
          </thead>
          <tbody>
            {FELLOWSHIP_KEYS.map(key => (
              <tr key={key} className="table-row">
                <td className="table-cell fellowship-col filled-cell">
                  <strong>{t(`fellowships.entries.${key}.name`)}</strong>
                </td>
                <td className="table-cell day-time-col">{t(`fellowships.entries.${key}.time`)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile: Cards */}
      <div className="fellowships-mobile-cards">
        {FELLOWSHIP_KEYS.map(key => (
          <div key={key} className="fellowship-mobile-card">
            <div className="fellowship-mobile-title">{t(`fellowships.entries.${key}.name`)}</div>
            <div className="fellowship-mobile-details">
              {t(`fellowships.entries.${key}.time`)}
            </div>
          </div>
        ))}
      </div>

      <div className="fellowships-cta">
        <a href="/fellowships" className="btn-view-all-fellowships">
          {t('fellowships.viewAll')}
        </a>
      </div>
      </div>
    </section>
  );
};

export default FellowshipsTable;
